export const buttons = {
  btnOptionsGrid: ".btn-options-grid",
  btnOptionsList: ".btn-options-list",
  listClass: "list-view",
  viewContainer: ".view-products-container"
};

export const siteConfig = {
  storageView: "view"
};

export const carousel = {
  mainContainer: "swiper-container.swiper-main",
  slideContainer: "swiper-slide:not(.swiper-slide-active)",
  iframe: "iframe",
  video: "video"
};
